exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rectangle-parent {\n  text-align: center;\n  display: table;\n  width: 100%;\n  height: 400px;\n  background-color: #dfe4e7; }\n\n.rectangle-child {\n  display: table-cell;\n  vertical-align: middle;\n  padding-left: 20px; }\n\ninput[type='file'] {\n  opacity: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/upload-file/upload-file.component.scss
// module id = ../../../../../src/app/securities-level/upload-file/upload-file.component.scss
// module chunks = main